module.exports = __webpack_public_path__ + "static/kraken-banner-11f213f6dafb93944845f819006039d7.png";